import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";

import InputWithLabel from "src/shared/components/Input/InputWithLabel";
import { largeScreen } from "src/shared/constants/screenSizes";

const AddAMessage = styled.div`
  display: flex;
  margin: 10px 0;

  label {
    margin: 0;
  }
`;

const ChooseButtonsContainer = styled.div`
  display: grid;
  grid-gap: 2vw;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  margin-bottom: 15px;
  width: 100%;

  @media (min-width: ${largeScreen}px) {
    grid-gap: 0.5vw;
  }
`;

const RequestFormDiv = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  left: 0;
  margin-top: 15px;
  z-index: 99;
`;

const RequestFormSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasMargin }) => (hasMargin ? "24px" : "0px")};
`;

const RequestFormSectionHeader = styled(Title)`
  color: ${colors.koalaGrey};
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
`;

const RequestFormSectionText = styled(Title)`
  color: ${colors.wolfGrey};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 15px;
`;

const RequestFormBreak = styled.hr`
  background-color: ${colors.rabbitGrey};
  margin: 5px 0 15px 0;
`;

const RequestFormToggleDiv = styled.div`
  padding-bottom: 15px;
`;

const TextInput = styled(InputWithLabel)`
  width: 100%;
`;

AddAMessage.displayName = "AddAMessage";
ChooseButtonsContainer.displayName = "ChooseButtonsContainer";
RequestFormDiv.displayName = "RequestFormDiv";
RequestFormSectionContainer.displayName = "RequestFormSectionContainer";
RequestFormSectionHeader.displayName = "RequestFormSectionHeader";
RequestFormSectionText.displayName = "RequestFormSectionText";
RequestFormBreak.displayName = "RequestFormBreak";
RequestFormToggleDiv.displayName = "RequestFormToggleDiv";

export {
  AddAMessage,
  ChooseButtonsContainer,
  RequestFormDiv,
  RequestFormSectionContainer,
  RequestFormSectionHeader,
  RequestFormSectionText,
  RequestFormBreak,
  RequestFormToggleDiv,
  TextInput
};
